var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Social/Instagram Copy 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M16 2.88315C15.405 3.14513 14.771 3.31878 14.11 3.40309C14.79 2.99557 15.309 2.35518 15.553 1.58329C14.919 1.96271 14.219 2.23071 13.473 2.38027C12.871 1.73687 12.013 1.33838 11.077 1.33838C9.261 1.33838 7.799 2.81791 7.799 4.63168C7.799 4.89266 7.821 5.1436 7.875 5.38249C5.148 5.24899 2.735 3.93709 1.114 1.93862C0.831 2.43146 0.665 2.99557 0.665 3.60284C0.665 4.7431 1.25 5.75388 2.122 6.33906C1.595 6.32902 1.078 6.17545 0.64 5.93355C0.64 5.94358 0.64 5.95663 0.64 5.96968C0.64 7.56966 1.777 8.89862 3.268 9.20477C3.001 9.27804 2.71 9.31317 2.408 9.31317C2.198 9.31317 1.986 9.30113 1.787 9.25696C2.212 10.5608 3.418 11.5194 4.852 11.5505C3.736 12.4268 2.319 12.9548 0.785 12.9548C0.516 12.9548 0.258 12.9427 0 12.9096C1.453 13.8501 3.175 14.3871 5.032 14.3871C11.068 14.3871 14.368 9.36838 14.368 5.01813C14.368 4.87258 14.363 4.73206 14.356 4.59254C15.007 4.1288 15.554 3.54964 16 2.88315Z",
    fill: "#5F5F60"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTw);
export default __webpack_public_path__ + "static/media/tw.b8ac99935628f3a308f1d9f12e4bf94b.svg";
export { ForwardRef as ReactComponent };